import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"
import useAppPromotionTheme from "../hooks/useAppPromotionTheme"

export default function SabaPromotion({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode)
  const data = promotionsData.find(
    (promo) => promo.title === "World Cup Weekly Lottery"
  )
  const [isMobile, setIsMobile] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>World Cup Weekly Lottery</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions
              </a>
              / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1>World Cup Weekly Lottery</h1>
                  <h2>2026 FIFA World Cup</h2>
                  <div className="promotion-tnc-period">
                    <strong> Event Period: </strong>
                    <span>June 6 - July 31, 2026</span>
                  </div>
                </div>
                <div className="promotion-tnc-mechanic-content">
                  <strong>General Terms & Conditions</strong>
                  <ol>
                    <li>
                      <strong className="highlight"> SABA Sports </strong>{" "}
                      reserves the right to adjust event arrangements should any
                      changes to the{" "}
                      <strong className="highlight">2026 FIFA World Cup</strong>{" "}
                      schedule occur.
                    </li>
                    <li>
                      {" "}
                      <strong className="highlight"> SABA Sports </strong>{" "}
                      reserves the right to modify, suspend, or remove Pool
                      Betting events (or any part thereof) at its sole
                      discretion.{" "}
                    </li>
                    <li>
                      {" "}
                      <strong className="highlight"> SABA Sports </strong>{" "}
                      reserves the right to accept or decline any{" "}
                      <strong className="highlight"> pool bet. </strong>
                    </li>
                    <li>
                      {" "}
                      In the event of any violation or abuse by a player,{" "}
                      <strong className="highlight"> SABA Sports </strong>{" "}
                      reserves the right to resettle the pool prizes.{" "}
                    </li>
                    <li>
                      {" "}
                      <strong className="highlight"> SABA Sports </strong> shall
                      not be held liable should the pool draw fail to proceed
                      due to technical issues.
                    </li>
                    <li>
                      {" "}
                      <strong className="highlight"> SABA Sports </strong>{" "}
                      reserves the right to modify, suspend, or terminate this
                      promotion at any time.
                    </li>
                    <li>
                      {" "}
                      By participating in this event, users are deemed to have
                      agreed to all rules and terms.
                    </li>
                    <li>
                      {" "}
                      SABA Sports reserves the right of final interpretation of
                      this campaign.
                    </li>
                  </ol>
                  <strong> Weekly Lottery Prize Distribution </strong>
                  <p> June 1 - July 20, 2026 </p>
                  <ul>
                    <li>
                      {" "}
                      All eligible tickets will be randomly drawn by SABA
                      Sports.{" "}
                    </li>
                    <li>
                      {" "}
                      Each player is eligible to win only one prize per week.
                    </li>
                    <li>
                      {" "}
                      The draw will proceed in ascending order, starting from
                      the lowest prize tier.
                    </li>
                    <li>
                      {" "}
                      Tickets that do not win in the weekly draw will be
                      automatically entered into the World Cup After Party{" "}
                    </li>
                  </ul>
                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <tr>
                          <th colSpan={3}> Weekly Lottery </th>
                        </tr>
                        <tr>
                          <th> Prize Level </th>
                          <th> PRIZE (USD) </th>
                          <th> Winner </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td> Golden </td>
                          <td> 5,000 </td>
                          <td> 1 </td>
                        </tr>
                        <tr>
                          <td> Silver </td>
                          <td> 1,000 </td>
                          <td> 10 </td>
                        </tr>
                        <tr>
                          <td> Bronze </td>
                          <td> 100 </td>
                          <td> 150 </td>
                        </tr>
                        <tr>
                          <td> Iron </td>
                          <td> $25 Free Bet </td>
                          <td> 2,000 </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <strong> After Party </strong>
                  <p> June 1 - July 20, 2026 </p>

                  <ul style={{ marginBottom: "10px" }}>
                    <li>
                      During the promotion period, all tickets held by players
                      from each World Cup Weekly Lottery will be automatically
                      accumulated into the World Cup After Party pool.
                    </li>
                    <li>
                      {" "}
                      The total prize pool for the World Cup After Party will
                      increase as players place more bets on World Cup matches.
                    </li>
                    <li>
                      {" "}
                      Upon the conclusion of the event, the system will randomly
                      select 100 winners to evenly split the total prize pool.
                    </li>
                  </ul>
                  <strong> Lucky Spin Mechanism & Rewards </strong>
                  <p> June 1 - July 31, 2026 </p>
                  <ul>
                    <li> Players can earn a maximum of 10 Points per day. </li>
                    <li>
                      {" "}
                      Every 3 Points can be used to redeem 1 spin on the Daily
                      Lucky Spin wheel.
                    </li>
                    <li>
                      {" "}
                      All Points must be used on the same day; any unused Points
                      will expire and be voided at the time of the daily
                      reset.{" "}
                    </li>
                    <li>
                      {" "}
                      The draw results will be displayed immediately upon
                      completion of the spin.
                    </li>
                  </ul>
                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <tr>
                          <th colSpan={3}> Daily Lucky Spin </th>
                        </tr>
                        <tr>
                          <th> Prize Level </th>
                          <th> Prize (USD) </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td> First Prize </td>
                          <td> $100 Free Bet</td>
                        </tr>
                        <tr>
                          <td> Second Prize </td>
                          <td> $50 Free Bet </td>
                        </tr>
                        <tr>
                          <td> Third Prize </td>
                          <td> $25 Free Bet </td>
                        </tr>
                        <tr>
                          <td> Fourth Prize </td>
                          <td> $10 Free Bet </td>
                        </tr>
                        <tr>
                          <td> Fifth Prize </td>
                          <td> $5 Free Bet </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {!isAppPromo && (
                    <div className="promotion-tnc-cta">
                      <a className="promotion-cta-btn" href="/sportsbook">
                        PLAY NOW
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
